module.exports = [
	{
		"value": "",
		"label": "Onbekend"
	},
	{
		"value": "m",
		"label": "Man"
	},
	{
		"value": "f",
		"label": "Vrouw"
	}
];


//////////////////
// WEBPACK FOOTER
// ./js/modules/person/constants/PersonGenderOptions.json
// module id = 34
// module chunks = 0